import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { FUNDING_TRANSFER_BASE_PATH } from '../../../../../features/funding/transfer/funding-transfer-routing';

// This route exists just to provide breadcrumbs for the funding transfer subpages.
export const Route = createFileRoute('/_app/_clearing-core/funding/transfer/_transfer')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'funding-transfer',
        label: 'Funding',
        to: FUNDING_TRANSFER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
